import React, { useState } from 'react';
import LandingAdminSettings from './LandingAdminSettings';
import EcommerceAdminSettings from '../ecommerce/EcommerceAdminSettings';

const WebUnifiedAdminSettings = ({ user }) => {
  const [activeMasterTab, setActiveMasterTab] = useState('landing'); // 'landing' | 'store'

  return (
    <div className="unified-web-settings-wrapper bg-light min-vh-100 pb-5">
      
      {/* Selector Maestro Superior */}
      <div className="bg-white border-bottom shadow-xs py-3 px-4 mb-4 sticky-top" style={{ zIndex: 100 }}>
        <div className="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
          
          <div className="d-flex align-items-center gap-3">
            <div 
              className="bg-primary text-white rounded-3 d-flex align-items-center justify-content-center shadow-sm"
              style={{ width: '42px', height: '42px', fontSize: '1.3rem' }}
            >
              <i className="bi bi-globe2"></i>
            </div>
            <div>
              <h5 className="fw-black text-dark mb-0 tracking-tight" style={{ fontWeight: 800 }}>
                Panel Central de Configuración Web
              </h5>
              <small className="text-muted">
                Administrá en un solo lugar la portada institucional y el catálogo eCommerce de tu empresa.
              </small>
            </div>
          </div>

          {/* Switcher Maestro de Ámbito */}
          <div className="btn-group p-1 bg-light rounded-pill border shadow-xs" role="group">
            <button
              type="button"
              className={`btn rounded-pill px-4 py-2 fw-bold d-flex align-items-center gap-2 ${activeMasterTab === 'landing' ? 'btn-primary text-white shadow-sm' : 'btn-light text-secondary border-0'}`}
              onClick={() => setActiveMasterTab('landing')}
            >
              <i className="bi bi-layout-text-window-reverse"></i>
              <span>1. Portada Institucional (Home)</span>
            </button>

            <button
              type="button"
              className={`btn rounded-pill px-4 py-2 fw-bold d-flex align-items-center gap-2 ${activeMasterTab === 'store' ? 'btn-primary text-white shadow-sm' : 'btn-light text-secondary border-0'}`}
              onClick={() => setActiveMasterTab('store')}
            >
              <i className="bi bi-shop"></i>
              <span>2. Tienda Online / Catálogo</span>
            </button>
          </div>

        </div>
      </div>

      {/* Renderizado Dinámico del Módulo Seleccionado */}
      {activeMasterTab === 'landing' ? (
        <LandingAdminSettings user={user} />
      ) : (
        <EcommerceAdminSettings user={user} />
      )}

    </div>
  );
};

export default WebUnifiedAdminSettings;
